import React, { FC } from 'react'
import Editor from '@monaco-editor/react'
import { makeStyles } from 'transfix-ui/core'
import './styles.scss'

const useCodeEditorStyles = makeStyles({
  editor: {
    border: '1px solid #333',
    margin: '0px 5px 5px 5px',
    padding: '10px',
  },
})

const formatString = (value: string) => {
  try {
    const res = JSON.parse(value)
    return JSON.stringify(res, null, 2)
  } catch {
    return value
  }
}

interface ICodeEditorProps {
  value?: string
  language?: string
  onInputDataChange?: (inputData: string) => void
  height?: string
  width?: string
}

export const CodeEditor: FC<ICodeEditorProps> = ({
  height = '30vh',
  language = 'json',
  onInputDataChange,
  value,
  width = '40vw',
}) => {
  const classes = useCodeEditorStyles()

  return (
    <Editor
      height={height}
      width={width}
      language={language}
      value={formatString(value || '')}
      className={classes.editor}
      onChange={onInputDataChange ? val => onInputDataChange(val || '') : undefined}
      options={{
        fontFamily: 'monospace',
        fontSize: 13,
        matchBrackets: 'always',
        scrollbar: {
          horizontalSliderSize: 4,
          verticalSliderSize: 18,
        },
        wordWrap: 'on',
      }}
    />
  )
}
